import compact from 'lodash/compact';
import url from 'url';
import { IN_APP_REDIRECT } from '../../constants/queryParams';
import { getGuideItemSubscribeSuccessRedirectLink } from '../../utils/guideItem/getGuideItemPathname';
import getGuideItemProducts from '../../utils/guideItem/getGuideItemProducts';
import createSubscribeLink from '../../utils/subscription/createSubscribeLink';

const createAndOpenSubscribeLink = (guideItem, location, products, source) => {
  const subscribeSuccessRedirectLink = getGuideItemSubscribeSuccessRedirectLink(guideItem);
  const additionalParams = {
    sku: compact(products || getGuideItemProducts(guideItem)),
    ...(subscribeSuccessRedirectLink && {
      [IN_APP_REDIRECT]: subscribeSuccessRedirectLink,
    }),
  };

  const subscribeLink = url.format(
    createSubscribeLink({
      source: source || location?.query?.source,
      guideId: guideItem?.guideId,
      location,
      additionalParams,
    }),
  );

  // TODO: use historySingleton.push() instead of window.open() after figuring out how
  // to avoid calling history.replace(to) in withSyncedPlayerBehavior, or after deleting
  // withSyncedPlayerBehavior altogether.
  window.open(subscribeLink, '_self');
  // historySingleton.push(subscribeLink);
};

export default createAndOpenSubscribeLink;
